@if (blast()) {
  <div class="row col-md-12">
    <app-blast-load-informations
      [class]="isInformationsCollapsed() ? 'col-md-1' : 'col-md-5'"
      [blast]="blast()"
      [tirId]="tirId()"
      [qualityData]="qualityData()"
      [selectedHoleId]="holeSelected()"
      (addHole)="onAddHole()"
      (holeSelected)="onHoleSelected($event)"
      (collapseChanged)="onCollapseChanged($event)"
      >
    </app-blast-load-informations>
    <app-blast-load-data
      [class]="dataComponentClass()"
      [blast]="blast()"
      [qualityData]="qualityData()"
      [selectedHoleId]="holeSelected()"
      (holeSelected)="onHoleSelected($event)"
      >
    </app-blast-load-data>
  </div>
}
